import { Command } from 'commands/Commands';

export class PromoteToEditor extends Command {
  type: string = 'Member.PromoteToEditor';
  priority: number = 100;
}
